import * as types from '../service/actionTypes';

export default function reportState(state = {
                                        reportData: {},
                                        selectednumber: 5
                                    },
                                    action) {
    switch (action.type) {
        case types.REPORT_FOR_DAYS:
            return {
                ...state,
                reportData: action.reportData
            }
        case types.SELECTED_NUMBER:
            return {
                ...state,
                selectednumber: action.selectednumber
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/reportDataReducer.js